import React from 'react'

export const Input = ({ 
  id, 
  name, 
  type = "text", 
  required = false, 
  value, 
  onChange, 
  placeholder, 
  className = "",
  ...props 
}) => {
  return (
    <input
      id={id}
      name={name}
      type={type}
      required={required}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className={`w-full px-3 py-2.5 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-100 focus:border-teal-500 text-sm ${className}`}
      {...props}
    />
  )
}